import { useEffect, useRef } from "react";

/**
 * Keeps the latest value in a mutable ref without triggering re-renders.
 *
 * Useful for accessing up-to-date values inside effects and callbacks
 * without dependency churn.
 */
export function useLatest(value) {
  const ref = useRef(value);
  useEffect(() => { ref.current = value; }, [value]);
  return ref;
}